import React from 'react';
import moment from 'moment';
const reactStringReplace = require('react-string-replace');

function addMonthsToDate(date, m) {
    var d = new Date(date); //clone the date
    var years = Math.floor(m / 12);
    var months = m - years * 12;
    if (years) d.setFullYear(d.getFullYear() + years);
    if (months) d.setMonth(d.getMonth() + months);
    return d;
}
function getUrlParams() {
    // This function is anonymous, is executed immediately and
    // the return value is assigned to QueryString!
    var query_string = {};
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        // If first entry with this name
        if (typeof query_string[pair[0]] === 'undefined') {
            query_string[pair[0]] = decodeURIComponent(pair[1]);
            // If second entry with this name
        } else if (typeof query_string[pair[0]] === 'string') {
            var arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
            query_string[pair[0]] = arr;
            // If third or later entry with this name
        } else {
            query_string[pair[0]].push(decodeURIComponent(pair[1]));
        }
    }
    return query_string;
}

function post(path, params, method) {
    method = method || 'post'; // Set method to post by default if not specified.

    // The rest of this code assumes you are not using a library.
    // It can be made less wordy if you use one.
    let form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);

    for (let key in params) {
        if (params.hasOwnProperty(key)) {
            let hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', key);
            hiddenField.setAttribute('value', params[key]);

            form.appendChild(hiddenField);
        }
    }

    document.body.appendChild(form);
    form.submit();
}

function generateTermsText(onLinkClick, isApps) {
    let terms;
    const termsLink = window.VULOG_TRANSLATE('TERMS_LINK');
    const privacyLink = window.VULOG_TRANSLATE('PRIVACY_LINK');

    if (termsLink.indexOf('.pdf') > -1) {
        if (!isApps) {
            terms = reactStringReplace(
                window.VULOG_TRANSLATE('I confirm I am over 18 years old, and have read and accepted the {terms}'),
                '{terms}',
                (match, i) => (
                    <a
                        href={termsLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'underline' }}
                    >
                        {window.VULOG_TRANSLATE('terms of service')}
                    </a>
                )
            );
        } else {
            terms = reactStringReplace(
                window.VULOG_TRANSLATE('I confirm I am over 18 years old, and have read and accepted the {terms}'),
                '{terms}',
                (match, i) => (
                    <a href={`newtab:${termsLink}`} download="terms-of-service">
                        {window.VULOG_TRANSLATE('terms of service')}
                    </a>
                )
            );
        }
    } else {
        terms = reactStringReplace(
            window.VULOG_TRANSLATE('I confirm I am over 18 years old, and have read and accepted the {terms}'),
            '{terms}',
            (match, i) => (
                <a onClick={onLinkClick(termsLink)} href={'#/'}>
                    {window.VULOG_TRANSLATE('terms of service')}
                </a>
            )
        );
    }

    // privacy
    if (privacyLink.indexOf('.pdf') > -1) {
        if (!isApps) {
            terms = reactStringReplace(terms, '{privacy}', () => (
                <a href={privacyLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>
                    {window.VULOG_TRANSLATE('data privacy policy')}
                </a>
            ));
        } else {
            terms = reactStringReplace(terms, '{privacy}', () => (
                <a href={`newtab:${privacyLink}`} download="data-privacy-policy">
                    {window.VULOG_TRANSLATE('data privacy policy')}
                </a>
            ));
        }
    } else {
        terms = reactStringReplace(terms, '{privacy}', () => (
            <a onClick={onLinkClick(window.VULOG_TRANSLATE('PRIVACY_LINK'))} href={'#/'}>
                {window.VULOG_TRANSLATE('data privacy policy')}
            </a>
        ));
    }

    return terms;
}

function generatePrivacyText(onLinkClick, isApps) {
    let privacy;
    const privacyLink = window.VULOG_TRANSLATE('PRIVACY_LINK');
    if (privacyLink.indexOf('.pdf') > -1) {
        if (!isApps) {
            privacy = reactStringReplace(window.VULOG_TRANSLATE('I have read the {privacy}.'), '{privacy}', () => (
                <a href={privacyLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>
                    {window.VULOG_TRANSLATE('privacy policy')}
                </a>
            ));
        } else {
            privacy = reactStringReplace(window.VULOG_TRANSLATE('I have read the {privacy}.'), '{privacy}', () => (
                <a href={`newtab:${privacyLink}`} download="privacy-policy">
                    {window.VULOG_TRANSLATE('privacy policy')}
                </a>
            ));
        }
    } else {
        privacy = reactStringReplace(window.VULOG_TRANSLATE('I have read the {privacy}.'), '{privacy}', (match, i) => (
            <a onClick={onLinkClick(window.VULOG_TRANSLATE('PRIVACY_LINK'))} href={'#/'}>
                {window.VULOG_TRANSLATE('privacy policy')}
            </a>
        ));
    }
    return privacy;
}

function generateMarketingConsentText(onLinkClick) {
    if (
        window.VULOG_TRANSLATE('MARKETING_LINK') !== 'MARKETING_LINK' &&
        window.VULOG_TRANSLATE('marketingConsent_link_label') !== 'marketingConsent_link_label'
    ) {
        return reactStringReplace(
            window.VULOG_TRANSLATE('marketingConsent_label'),
            '{marketingConsent_link_label}',
            (match, i) => (
                <a onClick={onLinkClick(window.VULOG_TRANSLATE('MARKETING_LINK'))} href={'#/'}>
                    {window.VULOG_TRANSLATE('marketingConsent_link_label')}
                </a>
            )
        );
    } else {
        return window.VULOG_TRANSLATE('marketingConsent_label');
    }
}

function generateProfilingConsentText(onLinkClick) {
    if (
        window.VULOG_TRANSLATE('PROFILING_LINK') !== 'PROFILING_LINK' &&
        window.VULOG_TRANSLATE('profilingConsent_link_label') !== 'profilingConsent_link_label'
    ) {
        return reactStringReplace(
            window.VULOG_TRANSLATE('profilingConsent_label'),
            '{profilingConsent_link_label}',
            (match, i) => (
                <a onClick={onLinkClick(window.VULOG_TRANSLATE('PROFILING_LINK'))} href={'#/'}>
                    {window.VULOG_TRANSLATE('profilingConsent_link_label')}
                </a>
            )
        );
    } else {
        return window.VULOG_TRANSLATE('profilingConsent_label');
    }
}

function generateSurveyConsentText(onLinkClick) {
    if (
        window.VULOG_TRANSLATE('SURVEY_LINK') !== 'SURVEY_LINK' &&
        window.VULOG_TRANSLATE('surveyConsent_link_label') !== 'surveyConsent_link_label'
    ) {
        return reactStringReplace(
            window.VULOG_TRANSLATE('surveyConsent_label'),
            '{surveyConsent_link_label}',
            (match, i) => (
                <a onClick={onLinkClick(window.VULOG_TRANSLATE('SURVEY_LINK'))} href={'#/'}>
                    {window.VULOG_TRANSLATE('surveyConsent_link_label')}
                </a>
            )
        );
    } else {
        return window.VULOG_TRANSLATE('surveyConsent_label');
    }
}

function generateShareDataConsentText(onLinkClick) {
    if (
        window.VULOG_TRANSLATE('SHARE_DATA_LINK') !== 'SHARE_DATA_LINK' &&
        window.VULOG_TRANSLATE('shareDataConsent_link_label') !== 'shareDataConsent_link_label'
    ) {
        return reactStringReplace(
            window.VULOG_TRANSLATE('shareDataConsent_label'),
            '{shareDataConsent_link_label}',
            (match, i) => (
                <a onClick={onLinkClick(window.VULOG_TRANSLATE('SHARE_DATA_LINK'))} href={'#/'}>
                    {window.VULOG_TRANSLATE('shareDataConsent_link_label')}
                </a>
            )
        );
    } else {
        return window.VULOG_TRANSLATE('shareDataConsent_label');
    }
}

function generateGdprText(isApps) {
    const termsLink = window.VULOG_TRANSLATE('TERMS_LINK');
    const privacyLink = window.VULOG_TRANSLATE('PRIVACY_LINK');
    let gdpr = reactStringReplace(
        window.VULOG_TRANSLATE('I confirm I am over 16 years old, accept the {terms} and have read the {privacy}'),
        '{terms}',
        (match, i) => {
            if (!isApps) {
                return (
                    <a href={termsLink} target="_blank" rel="noopener noreferrer">
                        {window.VULOG_TRANSLATE('terms of use')}
                    </a>
                );
            }
            return (
                <a href={`newtab:${termsLink}`} download="terms-of-service">
                    {window.VULOG_TRANSLATE('terms of use')}
                </a>
            );
        }
    );

    gdpr = reactStringReplace(gdpr, '{privacy}', (match, i) => {
        if (!isApps) {
            return (
                <a href={privacyLink} target="_blank" rel="noopener noreferrer">
                    {window.VULOG_TRANSLATE('data privacy policy')}
                </a>
            );
        }
        return (
            <a href={`newtab:${privacyLink}`} download="terms-of-service">
                {window.VULOG_TRANSLATE('data privacy policy')}
            </a>
        );
    });

    return gdpr;
}

function generateVATText() {
    let vat = reactStringReplace(
        window.VULOG_TRANSLATE('Please click {here} to register your VAT details to our services.'),
        '{here}',
        (match, i) => <a href={window.VULOG_TRANSLATE('VAT_LINK')}>{window.VULOG_TRANSLATE('here')}</a>
    );
    return vat;
}

const dateFormat = () => (window.VULOG_CONFIG.US_DATE_FORMAT ? 'MM-DD-YYYY' : 'DD-MM-YYYY');

const formatDate = date =>
    moment.utc(date).isValid() ? moment.utc(date).format() : moment.utc(date, dateFormat()).format();

const formatCurrency = currency => window.VULOG_TRANSLATE(currency);

const getMedias = requiresPermissionRequest => {
    const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

    if (!iOS && (window.VULOG_CONFIG.FORCE_TO_TAKE_PHOTO || requiresPermissionRequest)) {
        // ANDROID
        // handle old browsers
        if (navigator.mediaDevices === undefined) {
            navigator.mediaDevices = {};
        }

        if (navigator.mediaDevices.getUserMedia === undefined) {
            navigator.mediaDevices.getUserMedia = function(constraints) {
                // First get ahold of the legacy getUserMedia, if present
                const getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

                // Some browsers just don't implement it - return a rejected promise with an error
                // to keep a consistent interface
                if (!getUserMedia) {
                    return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
                }

                // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
                return new Promise(function(resolve, reject) {
                    getUserMedia.call(navigator, constraints, resolve, reject);
                });
            };
        }
        navigator.mediaDevices
            .getUserMedia({ audio: true, video: true })
            .then(stream => {
                return stream.getTracks().forEach(track => track.stop());
            })
            .catch(err => console.log('error', err));
    }
};

function setCalendarLocale(locale) {
    if (!locale || locale.startsWith('en')) {
        moment.locale('en');
        return Promise.resolve();
    }
    return import(`moment/locale/${locale}`)
        .then(() => {
            moment.locale(locale);
        })
        .catch(() => {
            moment.locale('en');
        });
}
const updateComponent = () => {
    window.location.reload(false);
};

const isFieldRequired = name => {
    const requiredFields = window.VULOG_CONFIG && window.VULOG_CONFIG.REQUIRED_PERSONAL_DETAILS_FIELDS;
    return requiredFields && requiredFields.some(field => field === name);
};

const Helper = {
    getUrlParams,
    addMonthsToDate,
    post,
    generateGdprText,
    generatePrivacyText,
    generateTermsText,
    generateVATText,
    dateFormat,
    formatDate,
    formatCurrency,
    getMedias,
    updateComponent,
    setCalendarLocale,
    generateMarketingConsentText,
    generateProfilingConsentText,
    generateSurveyConsentText,
    generateShareDataConsentText,
    isFieldRequired,
};
export default Helper;
